<template>
  <div class="site__links">
    <div class="site__links__li">
      <div class="dummy"></div>
      <div class="dummy"></div>
      <div class="dummy"></div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.site__links {
  position: relative;
  margin-top: 20px;
}

.dummy {
  background: linear-gradient(to bottom, #b9b9b9, #ccc);
  height: 60px;
  margin-bottom: var(--p-btn-margin-bottom);
}
</style>
